import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import PaymentService from 'services/PaymentService';
import CustomButton from 'components/CustomButton';
import { useStyles } from './style';
import { Card } from 'styles/components/planDetailsCard';
import Image from 'next/image';
import { Icons } from 'components/Icons';
import { benefitsPricing } from 'utils/benefitsPricing';
import { useAuthUser } from 'features/auth/AuthUserContext';

export default function StarterPlanCardAlternative() {
  const router = useRouter();
  const { isAuthenticated } = useAuthUser();
  const classes = useStyles();
  const paymentService = new PaymentService();
  const [currentSubscription, setCurrentSubscription] = useState({});
  const [itemsBenefits, setItemsBenefits] = useState(6);
  const [latestInvoice, setLatestInvoice] = useState(null);
  const pathURL = router.pathname;

  function handleButtonClick() {
    if (latestInvoice) {
      router.push('/pricing');
      return;
    }

    router.push(`/pricing`);
  }

  useEffect(() => {
    async function fetchStripeSubscription() {
      try {
        const response = await paymentService.getStripeSubscription();

        if (response.data) {
          setCurrentSubscription(response.data);
        }
      } catch (e) {
        console.error(e);
      }
    }

    if (isAuthenticated) {
      fetchStripeSubscription();
    }
  }, [isAuthenticated]);

  useEffect(() => {
    setLatestInvoice(currentSubscription.latest_invoice);
  }, [currentSubscription]);

  return (
    <Card>
      <Typography className={classes.titlePink}>Not subscribed</Typography>

      <Typography className={classes.expiredText}>Your subscription has expired</Typography>

      <CustomButton onClick={handleButtonClick} variant="buttonSecondary" style={{ width: '100%' }}>
        {!latestInvoice ? 'Start free trial' : 'Renew subscription'}
      </CustomButton>

      <Box display="flex" justifyContent="center" width="100%">
        <Box display="flex" alignItems="center" pt={4}>
          <div className={classes.line} />
          <Typography style={{ color: '#D6246E', fontSize: 18, padding: '6px' }}>
            <b>You have access to:</b>
          </Typography>
          <div className={classes.line} />
        </Box>
      </Box>
      <Box display="flex" alignItems="start">
        <Box className={classes.benefitsList}>
          {benefitsPricing.slice(0, itemsBenefits).map((benefit) => (
            <div key={benefit.id}>
              <Icons.done />
              <p>{benefit.text}</p>
            </div>
          ))}

          <Box pt={2}>
            {itemsBenefits === 6 ? (
              <Typography
                className={classes.allFeatures}
                component="p"
                onClick={() => setItemsBenefits(17)}
              >
                See All Features
              </Typography>
            ) : (
              <Typography
                className={classes.allFeatures}
                component="p"
                onClick={() => setItemsBenefits(5)}
              >
                See less features
              </Typography>
            )}
          </Box>
        </Box>

        <Box pt={1}>
          <Image src="/images/cool-scientist.svg" alt="cool scientist" width={316} height={193} />
        </Box>
      </Box>
    </Card>
  );
}
